import { DON_HANG_MUA_TRONG_NUOC_STATUS_MAP } from './constant';
import type { ExcelColumnMapping } from './types';
import { formatDate } from '@/lib/formatUtils';

export const DON_HANG_MUA_TRONG_NUOC_COLUMNS: ExcelColumnMapping[] = [
  {
    header: 'Trạng thái',
    width: 16,
    resolver: row => DON_HANG_MUA_TRONG_NUOC_STATUS_MAP[row.status] || row.status || ''
  },
  {
    header: 'Số c/từ',
    width: 18,
    resolver: row => row.so_ct || ''
  },
  {
    header: 'Ngày c/từ',
    width: 16,
    resolver: row => formatDate(row.ngay_ct)
  },
  {
    header: 'Mã nhà cung cấp',
    width: 18,
    resolver: row => row.ma_kh_data?.ma_kh || row.ma_ncc_data?.ma_kh || row.ma_kh || row.ma_ncc || ''
  },
  {
    header: 'Tên nhà cung cấp',
    width: 28,
    resolver: row => row.ma_kh_data?.ten_kh || row.ma_ncc_data?.ten_kh || row.ten_kh || row.ten_ncc || ''
  },
  {
    header: 'Diễn giải',
    width: 40,
    resolver: row => row.dien_giai || ''
  },
  {
    header: 'Tổng tiền',
    width: 18,
    resolver: row => Number(row.t_tt_nt ?? row.t_tt ?? 0)
  },
  {
    header: 'Ngoại tệ',
    width: 12,
    resolver: row => row.ma_nt_data?.ma_nt || row.ma_nt || ''
  },
  {
    header: 'Loại chứng từ',
    width: 18,
    resolver: () => '5. Đơn hàng'
  },
  {
    header: 'Người tạo',
    width: 22,
    resolver: row => row.user_id0_data?.username || ''
  },
  {
    header: 'Ngày tạo',
    width: 20,
    resolver: row => formatDate(row.created)
  },
  {
    header: 'Người sửa',
    width: 22,
    resolver: row => row.user_id2_data?.username || ''
  },
  {
    header: 'Ngày sửa',
    width: 20,
    resolver: row => formatDate(row.updated)
  }
];
